<template>
  <div id="content" class="assessment_summary">
    <div class="container">


      <div class="assessment_summary" >
        <div class="row">
          <div class="col-12 text-center">
            <span class="title">Project {{project_summary.name}}</span>
          </div>
        </div>
        <div class="col-12 text-center mt75" v-if="project_summary">
          <div class="item_card">
            <span class="item_card_title">MY CHALLENGE</span>
            <div class="row item_card_content">
              <div class="col-12 col-xl-6" v-if="project_summary.business_challenge">
                <div class="assessment_summary_item">
                  <img :src="require('@/assets/search_field_1_problem_to_be_solved.svg')" class="assessment_summary_item_img"/>
                  <span class="assessment_summary_item_title">Problem to be solved</span>
                  <div class="assessment_summary_item_content"  v-if="project_summary.business_challenge.business_opportunity">
                    {{project_summary.business_challenge.business_opportunity}}
                  </div>

                </div>
              </div>
              <div class="col-12 col-xl-6" v-if="project_summary.business_challenge" >
                <div class="assessment_summary_item" >
                  <img :src="require('@/assets/search_field_1_partnership_objective.svg')" class="assessment_summary_item_img"/>
                  <span class="assessment_summary_item_title">Partnership objective</span>
                  <div class="assessment_summary_item_content" v-if="project_summary.business_challenge.partnership_objectives">
                    <ul>
                      <li v-for="(po,i) in project_summary.business_challenge.partnership_objectives" :key="i" >
                        {{po.replaceAll("_"," ")}}
                      </li>
                    </ul>

                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="row mt50" >
           <div class="" >
             <div class="col-12 text-center" >
               <span class="title">MY SELECTED CANDIDATES FOR {{project.name}}</span>
             </div>
            <div class="row">
              <div class="col-12 col-lg-6 col-xl-4 candidate" v-for="(candidate, c) in project.candidate_to_assess" :key="c">
                <div class="candidate_card" >
                  <div class="candidate_card_head">
                    <span class="name">{{candidate.startup.name}}</span>


                  </div>
                  <div class="candidate_info_content">

                      <StartupInfoLine v-if="candidate.startup.value_proposition" name="Value proposition" :value="candidate.startup.value_proposition" />
                      <StartupInfoLine v-else name="Value proposition" value="No data" />

                      <StartupInfoLine v-if="candidate.startup.solution" name="Solution" :value="candidate.startup.solution" />
                      <StartupInfoLine v-else name="Solution" value="No data" />

                        <StartupInfoLine v-if="candidate.collab_interest_level" name="My interest level" :value="candidate.collab_interest_level" />



                  </div>
                    <div class="website" v-if="candidate.startup.website">
                       <a :href="candidate.startup.website" target="_blank">{{candidate.startup.website.replace(/^https?:\/\//, '').replace(/\/$/, '')}}</a>
                    </div>
                  <div class="footer">


                    <router-link :to="'/startup_report/'+this.$route.params.sid+'/'+candidate.startup._id.$oid+'/'+this.$route.params.pid" >
                    See full report  <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
<g fill="none" stroke="#4c81c0" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10">
<path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
</g>
</svg>
                    </router-link>
                  </div>


                      </div>
                    </div>

            </div>
          </div>

        </div>


        <div class="row">
          <div class="col-12  text-right">
            <router-link class="prev_step_btn" :to="'/projet/'+this.$route.params.pid" v-if="this.$route.params.pid">
              <img :src="require('@/assets/prev.svg')" alt="">
              BACK TO PROJECT DASHBOARD
            </router-link>
          </div>
        </div>

        </div>


    </div>
  </div>
</template>
<script>

import api from '../tools/api';
import StartupInfoLine from '@/components/InfoStartupLine.vue'


 import { toast } from 'vue-sonner'
export default {
  components: {
StartupInfoLine
  },
  name: 'AssessmentSpace',
  data() {
    return {
      pageInfo: {
        mainTitle : "Assessment space",
        subTitle : "My selected candidates",
      },
      apiUrl: process.env.VUE_APP_API_URL,
      isSubmit : false,
      project: {},
      project_summary : {},
    }
  },
  methods:{
    gobackrouter : function(){
      this.$router.go('/projet/'+this.$route.params.pid);
    },


  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

     api.get(process.env.VUE_APP_API_URL+"/restrict/sf_summary/"+this.$route.params.sid).then( (r) => {
       // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
       // console.log();
       // var temp = _.merge(this.candidatespool, r.data)
       console.log(r.data);
       this.project = r.data;
     }).catch( (e) => {
       console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
   });
   api.get(process.env.VUE_APP_API_URL+"/restrict/project_summary/"+this.$route.params.pid).then( (r) => {
     // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
     // console.log();
     // var temp = _.merge(this.candidatespool, r.data)
     console.log(r.data);
     this.project_summary = r.data;
   }).catch( (e) => {
     console.log(e);
      toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
 });

  },
  computed:{
    selectedCandidates: function(){
      var selectedCandidatesTemp = [];
      this.assessment.candidates.forEach((c) => {
              if(c.compare == true)selectedCandidatesTemp.push(c);
      });
      return selectedCandidatesTemp;
    }
  }

}
</script>
<style scoped>
.assessment_summary{
  padding-top:50px;
  padding-bottom:50px;
}
.all_candidates_download_zone{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}


.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
}
.all_candidates_download_zone .description{
  display:block;
  margin-top:10px;
  margin-bottom: 20px;
  width:100%;
}

  .next_step_btn{
    background: #3783C5 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 14px 37px;
    color:#FFF;
    margin:5px;
  }
  .next_step_btn img.left{
    margin-right:10px;
  }
img.goFullWhite{
  filter: brightness(0) invert(1);
}
.assessment_summary{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
margin-bottom:50px;
}

.pool_title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
}
.pool_subtitle{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
display:block;
}
.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}

.mt50{
  margin-top: 50px;
}

.selection{
  margin-top:50px;
  border-top:1px solid #DDD;
  padding-top: 50px;

}
.selection .selectedOne{
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  width: calc(33% - 20px);
}
.selection .selectedOne img{
    width: 65px;
    height:65px;
    border-radius: 6px;
    object-fit: cover;
    margin-right: 10px;
}

.selection .candidateSelection{
  display:flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top:50px;
}

@media screen and (max-width: 1200px){
  .selection .selectedOne{
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    width: calc(50% - 20px);
  }
}
@media screen and (max-width: 990px){
  .selection .selectedOne{
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    width: calc(100%);
  }
  .selection .candidateSelection{
    flex-direction: column;
  }
}

.onePool:not(:first-of-type){
  margin-top:50px;
}

.askNewPool button{
  font-size:12px;
  line-height: 15px;
}
.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    display:inline-block;
}
.prev_step_btn img{
  margin-right:10px;
}
a{
  color:inherit;
  text-decoration: none;
}

.item_card{
  border: 1px solid #DDD;
  border-radius: 10px;
padding: 20px;
position:relative;
padding-top: 40px;
margin-top: 20px;
}
.item_card .item_card_title{
  position:absolute;
  top: 0px;
  transform: translate(-50%,-50%);
  left: 50%;
  background: #FFF;
  color: #3783C5;
text-transform: uppercase;
font-weight: 500;
font-size:24px;
line-height: 29px;
  padding-left: 20px;
  padding-right: 20px;
}


.assessment_summary_item{
  width: 90%;
  margin:auto;
  margin-top:20px;
  margin-bottom: 20px;
position: relative;
}
.assessment_summary_item_img{
  width: 55px;
position: absolute;
top: -25px;
left: -25px;
}
.assessment_summary_item_title{
  position: absolute;
top: 0;
left: 50px;
background: #FFF;
transform: translateY(-50%);
padding-left: 10px;
padding-right: 10px;
padding-top: 6px;
padding-bottom: 6px;
font-size: 16px;
line-height: 15px;
color: #3783C5;
}
.assessment_summary_item_subtitle{
  color: #000;
  font-size: 12px;
}
.assessment_summary_item_content{
  padding-top: 20px;
  padding-left:65px;
  text-align:left;
}


.startup_compare_header span{
  color: #3783C5;
text-transform: uppercase;
font-size:18px;
line-height: 21px;
display:block;
margin-top:10px;
margin-bottom: 20px;

}

.startup .roundImage{
border: 2px solid #B38D2F;
padding: 5px;
border-radius: 50%;
border-right: none;
border-top: none;
}

.startup:nth-child(2n+1) .roundImage{
border: 2px solid #6C68A2;
padding: 5px;
border-radius: 50%;
border-right: none;
border-top: none;
}

.roundImage{
  /* border-radius: 50%; */
  width:96px;
  height:96px;
  object-fit: cover;
  object-position: center;
  /* mask: url('~@/assets/mark_yellow.svg#mask'); */
}

.startup{
  margin-top:20px;
  margin-bottom: 20px;
}

.seeFull{
  border-bottom: 1px solid #DDD;
  padding-bottom: 20px;
  padding-top: 20px;
  color: #3783C5;
text-transform: uppercase;
font-size:12px;
line-height:15px;
}



.barcontainer{
  background-color: #DDDDDD;
  position: relative;

  width: 30px;
  height: 200px;
  margin-left: 115px;
}
.bar{
  background-color: #3783C5;
  position: absolute;
  bottom: 0;
  width: 100%;

  box-sizing: border-box;
  -webkit-transition: all 0.5s linear;
      -moz-transition: all 0.5s linear;
      -o-transition: all 0.5s linear;
      transition: all 0.5s linear;
  transform-origin: bottom;
}
.bar.low{
  height: 10%;
}
.bar.medium{
  height: 50%;
}

.bar.high{
  height: 90%;

}

@keyframes grow{
  from{
    transform: scaleY(0);
  }
}

.jauge_label.low{
  position: absolute;
  bottom :10%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label.medium{
  position: absolute;
  bottom :50%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}


.jauge_label.high{
  position: absolute;
  top :10%;
  transform: translateY(-50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label::before{
  content :" ";
  background: #707070;
  width:10px;
  height:1px;
  left: -10px;
  position:absolute;
  top: 50%;
}
.jauge_label input{
  width:22px;
  height:22px;
}

.jauge_label span{
  display:block;
  color: #3783C5;
  font-size: 14px;
  line-height: 22px;
  width:100%;
  font-weight: 500;
  text-transform:uppercase;
}
.jauge_label small{
  color: #575757;
  font-weight: 300;
  font-size:14px;
  line-height: 22px;
}
.info{
    display: flex;
    flex-direction: column;
    padding: 5px;
}

.flex{
  display:flex;
  align-items: center;
    gap: 20px;
}
.barLabel{
  color: #3783C5;
  font-size:18px;
  line-height: 21px;
}
@media screen and (max-width:1200px){
  .flex{
    flex-direction: column;

    align-items: flex-start;
  }
}


.interest{
  margin-top: 30px;
  margin-bottom: 30px;
  text-align:center;
}

.interest_title{
  color: #3783C5;
  font-size:18px;
  line-height: 21px;
  display:block;
  margin-bottom: 20px;
}
.foot small{
  font-size:11px;
  margin-left:10px;
  margin-right:10px;
}

.mt75{
  margin-top:75px;
}


.candidate_comments{
  padding: 20px 50px;
  border-top: 1px solid #DDD;
  margin-top:auto;
}
.candidate_comments .one_comment{
  margin-top:10px;
  margin-bottom: 10px;
  font-size:12px;
  line-height:15px;
    position:relative;
}
.candidate_comments .one_comment:after {
  content: ""; /* This is necessary for the pseudo element to work. */
     display: block; /* This will put the pseudo element on its own line. */
     margin: 0 ; /* This will center the border. */
     width: 20%; /* Change this to whatever width you want. */
     padding-top: 10px; /* This creates some space between the element and the border. */

     border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
}
.candidate_comments small{
  font-size:12px;
}

.jauge_label{
  text-align:left !important;
}

.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}


.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}

.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}
@media screen and (max-width: 690px){
  .candidate_card .candidate_links{
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px
  }
  .candidate_pool{
      padding: 20px;
    }
    .candidate_card .candidate_links .details{
      border-right: none;
      border-bottom:1px solid #DDD;
      padding-bottom: 20px;
    }
    .candidate_card .candidate_links .selectIt label{
    display:flex;
    align-items: center;
    gap: 5px;
    justify-content: start;
    flex-direction: row-reverse;
    }
    .filtre_list {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-rows: 100%;
  gap: 10px;
}
}
.candidate_card_head{
  background: transparent linear-gradient(270deg, #3783C5 0%, #1368B2 100%) 0% 0% no-repeat padding-box;

  padding: 10px;
  color: #FFF;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 10px 10px 0px 0px;
  display:flex;
  align-content: center;
    align-items: center;
gap:10px;
min-height: 60px;
}
.candidate_card_head .name{
  flex:1;
}
.candidate_info_content{
  padding:10px;
}
.footer{
padding-left: 20px;
  padding-right: 20px;
    padding-bottom: 10px;
  font-weight:bold;
  text-transform: uppercase;
  color:#B38D2F !important;
  font-size:14px;
  display:flex;
  flex-wrap:wrap;
  gap:10px;
  margin-top: auto;
}

.footer a{
  margin-left: auto;
}
.footer *{
  color:#4c81c0 !important;
  font-size:14px;
}

.website{
  color:#4c81c0 !important;
  font-size:14px;
  text-align:center;
  margin-bottom:20px;
  font-weight:700;
}

.website a{
  color:#4c81c0 !important;
}
</style>
